export default "__VITE_PUBLIC_ASSET__6f2de577__"